// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__cKVOM","paramInput":"JobSimulator_paramInput__1Gy6S","input":"JobSimulator_input__3y8hI"};